var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSensor2Legend = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 11.714,
    viewBox: "0 0 35 11.714",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2156 -449)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "sensor2a",
    x2: 35,
    transform: "translate(2156 454.85)",
    fill: "none",
    stroke: "#000",
    strokeDasharray: "4 2"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2167.7 454.857) rotate(-45)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "sensor2b",
    d: "M 7.632509231567383 7.632509231567383 L 0.4915326535701752 7.508467197418213 L 0.3674907684326172 0.3674907684326172 L 7.508467197418213 0.4915326535701752 L 7.632509231567383 7.632509231567383 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    className: "sensor2c",
    d: "M 0.8764119148254395 0.8764119148254395 L 0.9830751419067383 7.016924858093262 L 7.123588085174561 7.123588085174561 L 7.016924858093262 0.9830751419067383 L 0.8764119148254395 0.8764119148254395 M -0.1414203643798828 -0.1414203643798828 L 8 0 L 8.141420364379883 8.141420364379883 L 0 8 L -0.1414203643798828 -0.1414203643798828 Z",
    stroke: "none",
    fill: "#000"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSensor2Legend);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/sensor2-legend.ea07f3ae2ff2dc2985f011d479e66173.svg";